import type { ReactNode } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { isBenchmarkProtectedRouteBypass } from "../config/benchmarkDesignMode";
import { useAuth } from "../context/AuthContext";
import { evaluateProtectedRouteGuard } from "../services/protectedRouteGuard";

type ProtectedRouteProps = {
  children: ReactNode;
  role?: "publisher" | "founder";
};

export function ProtectedRoute({ children, role = "publisher" }: ProtectedRouteProps) {
  const { user, isLoading } = useAuth();
  const location = useLocation();

  /*
   * Bootstrap/design review — only Screen 6 publish layout may render without a
   * frontend session. Publisher Dashboard and ownership-sensitive routes always
   * use the normal authenticated guard below.
   */
  if (isBenchmarkProtectedRouteBypass(location.pathname)) {
    return children;
  }

  const decision = evaluateProtectedRouteGuard(
    { isLoading, user, requiredRole: role },
    location.pathname,
  );

  if (decision.action === "loading") {
    return (
      <div className="container py-5 text-center text-muted">Loading...</div>
    );
  }

  if (decision.action === "redirect") {
    return (
      <Navigate replace state={decision.state} to={decision.to} />
    );
  }

  return children;
}
